import React, { useState, useEffect } from 'react';
import Header from "@/components/common/header/DefaultHeader";
import MobileMenu from '@/components/common/header/MobileMenu';
import './Careers.css';
import Footer from '@/components/common/footer/Footer';
import { getWebCMS } from '@/api/PDP';
import OtherLinkFooter from '../common/footer/OtherLinkFooter';
import NewFooter from '../common/footer/NewFooter';


const Careers = () => {
    const [cmsData, setCmsData] = useState('');

    useEffect(() => {
        const fetchCMSData = async () => {
            try {
                const response = await getWebCMS("pages/careers");
                setCmsData(response?.results?.[0]);
            } catch (error) {
                console.error("Error fetching CMS data:", error);
            }
        };

        fetchCMSData();
    }, []);

    const whoWeAreCard = [
        {
            id: 1,
            title: cmsData?.whoWeAre?.card1?.header,
            description: cmsData?.whoWeAre?.card1?.content,
            imageUrl: cmsData?.whoWeAre?.card1?.cardImage
        },
        {
            id: 2,
            title: cmsData?.whoWeAre?.card2?.header,
            description: cmsData?.whoWeAre?.card2?.content,
            imageUrl: cmsData?.whoWeAre?.card2?.cardImage
        }, {
            id: 3,
            title: cmsData?.whoWeAre?.card3?.header,
            description: cmsData?.whoWeAre?.card3?.content,
            imageUrl: cmsData?.whoWeAre?.card3?.cardImage
        },
    ]
    const whatWeOfferCard = [   //build a dynamic array -
        {
            id: 1,
            title: cmsData?.whatWeOffer?.card1?.header,
            description: cmsData?.whatWeOffer?.card1?.content,
            imageUrl: cmsData?.whatWeOffer?.card1?.cardImage
        },
        {
            id: 2,
            title: cmsData?.whatWeOffer?.card2?.header,
            description: cmsData?.whatWeOffer?.card2?.content,
            imageUrl: cmsData?.whatWeOffer?.card2?.cardImage
        }, {
            id: 3,
            title: cmsData?.whatWeOffer?.card3?.header,
            description: cmsData?.whatWeOffer?.card3?.content,
            imageUrl: cmsData?.whatWeOffer?.card3?.cardImage
        },
    ]
    const quotes = [
        cmsData?.whatPeopleSay?.quote1,
        cmsData?.whatPeopleSay?.quote2,
        cmsData?.whatPeopleSay?.quote3
    ]

    const resourcedata = [
        cmsData?.whoWeLookingFor?.listData1,
        cmsData?.whoWeLookingFor?.listData2,
        cmsData?.whoWeLookingFor?.listData3,
        cmsData?.whoWeLookingFor?.listData4,
        cmsData?.whoWeLookingFor?.listData5,
    ]
    return (
         <>
         <div className="in-the-news">
            <Header />
            <MobileMenu />
            <header
                className="stricky-fixed"
            >
            </header>
            {/* Banner section */}
            <div className="container-fluid p-0">
                <div className="position-relative text-center text-white">
                    <img
                        src={cmsData?.careersBanner}
                        className="img-fluid w-100"
                        alt="Banner"
                        style={{ height: '60vh', objectFit: 'cover' }} />
                    <div className="position-absolute top-50 start-50 translate-middle p-4 rounded">
                        <h1 className='careers-title'>Join Our Team</h1>
                        <button className="btn btn-danger mt-3 careers-btn"><a href={cmsData?.careersLink} style={{ color: "#fff" }}>Explore Opportunities</a></button>
                    </div>
                </div>
            </div>
            {/* card section */}
            <div className="container my-4 pt60">
                <div className="text mb-4">
                    <h1>{cmsData?.whoWeAre?.header}</h1>
                    <p>{cmsData?.whoWeAre?.description}</p>
                </div>
                <div className="row">
                    {whoWeAreCard.map((card) => (
                        <div key={card?.id} className="col-md-4 mb-4">
                            <div className="card h-100">
                                <img src={card?.imageUrl} className="card-img-top" alt={`Card ${card?.id}`} />
                                <div className="card-body">
                                    <h4 className="card-title">{card?.title}</h4>
                                    <p className="card-text">{card?.description}</p>
                                </div>
                            </div>
                        </div>
                    ))}
                </div>
            </div>
            {/* what we offer section */}

            <div>

                <h2 className='text-center'>{cmsData?.whatWeOffer?.title}</h2>

                <div className="top-background"></div>
                <div className="card-section" style={{ padding: '0px 10%' }}>
                    <div className="text mb-4">
                        <h1 className='whatWeOffer'>{cmsData?.whatWeOffer?.header}</h1>
                        {/* <h3>
                            {cmsData?.whatWeOffer?.description}
                        </h3> */}
                    </div>
                    <div className="row">
                        {whatWeOfferCard.map((card) => (
                            <div key={card?.id} className="col-md-4">
                                <div className="card h-100">
                                    <img src={card?.imageUrl} className="card-img-top" alt={`Card ${card?.id}`} />
                                    <div className="card-body">
                                        <h5 className="card-title">{card?.title}</h5>
                                        <p className="card-text">{card?.description}</p>
                                    </div>
                                </div>
                            </div>
                        ))}
                    </div>
                </div>
                <div className="bottom-background"></div>
            </div>
            {/* glassdoor */}
            <div className="Quotes-section" style={{ padding: "160px" }}>
                <div className="text mb-4">
                    <h1>{cmsData?.whatPeopleSay?.header}</h1>
                </div>
                <div className="row pb-2 careers-quote">
                    {quotes.map((card, index) => (
                        <div key={index} className="col-md-4">
                            <div className="p-4">
                                <p className="card-text col-xs-12 col-sm-4 col-lg-8 review color-dbGray careers-quote">{card}</p>
                            </div>
                        </div>
                    ))}
                </div>
                <h4 style={{ textAlign: 'center' }}>See more on <a target='blank' className='glassdoor-link' href={cmsData?.whatPeopleSay?.glassdoorLink}>Glassdoor!</a></h4>
            </div>
            {/* explore opportunities section */}
            <div className="container-fluid explore-opportunities" style={{ padding: "100px" }}>
                <div className="row">
                    <div className="col-md-6 p-lg-5">
                        <h1 className='whatWeOffer'>{cmsData?.whoWeLookingFor?.header}</h1>
                        <p className='careers-text-color'>{cmsData?.whoWeLookingFor?.para1}</p>
                        <ul className='pl40' style={{ listStyle: 'circle' }}>
                            {resourcedata.map((item, index) => (
                                <li className="" key={index}>{item}</li>
                            ))}
                        </ul>
                        <p className='careers-text-color'>{cmsData?.whoWeLookingFor?.para2}</p>

                        <p></p>
                        <button className="btn btn-danger careers-btn my-4" style={{ color: '#fff' }}><a href={cmsData?.careersLink} className='text-light'>Explore Opportunities</a></button>
                        <p style={{ padding: '20px 0px' }} className='text-light'>
                            {cmsData?.whoWeLookingFor?.contactUsStartPara}
                            <span><a className='underLine' href={cmsData?.whoWeLookingFor?.mailTo} style={{ color: '#fff', textDecoration:"underline !important"}}>{cmsData?.whoWeLookingFor?.hubzuMail}</a></span>
                            {cmsData?.whoWeLookingFor?.contactUsEndPara}                        </p>
                    </div>
                    <div className="col-md-6 d-flex justify-content-center align-items-center">
                        <img src={cmsData?.whoWeLookingFor?.findCandidateImage} alt="Job Opportunity" className="img-fluid" />
                    </div>
                </div>
            </div>
            <div className='text-center' style={{ padding: '60px' }}>
                <h1>{cmsData?.learnMore?.header}</h1>
                <p>{cmsData?.learnMore?.para1}<span><a href={cmsData?.learnMore?.aboutUsUrl} style={{color:"#118bf4"}} >{" " + cmsData?.learnMore?.para2}</a></span>{cmsData?.learnMore?.para3}</p>
            </div>
            {/* footer */}
            {/* <section className="footer_one home6 bg-ptrn2">
                <div className="container">
                    <div className="row">
                        <Footer />
                    </div>
                </div>
            </section> */}
               <div className="container-fluid px-0">
                            {/* <Footer /> */}
                            <OtherLinkFooter/>
                            <NewFooter/>
                        </div>
        </div></>
    );
};

export default Careers;
